import {
  useComponentsToAnimate,
  useControllerScrollAnimations,
  useDeniedAnimationNodes,
  useRegisterShouldAnimate,
} from "context/SiteProvider";
import CfStrip from "../CfStrip";
import React, { useEffect, useRef, useState } from "react";
import ScrollMagic, { Scene } from "scrollmagic";
// NOTE: is for debug ScrollMagic
// import "debug.addIndicators";
import * as styles from "./index.module.scss";
import { CfStripProps } from "../types";
import cn from "classnames";

const Strip = (props: CfStripProps) => {
  const strip = useRef<HTMLDivElement>(null);
  const registerShouldAnimate = useRegisterShouldAnimate();
  const componentsToAnimate = useComponentsToAnimate();
  const deniedAnimationNodes = useDeniedAnimationNodes();
  const [deniedNode, setDeniedNode] = useState(true);

  const controllerScrollAnimations = useControllerScrollAnimations();

  const scene = useRef<Scene>();

  useEffect(() => {
    if (strip.current && registerShouldAnimate) {
      const remove = registerShouldAnimate(strip.current);
      return () => {
        remove();
      };
    }
    return () => {};
  }, [registerShouldAnimate]);

  // NOTE: set if strip can animate. Every page can animate in page enabling a flag in cms. All strip are animated except the first and last on the page. Furthermore are excluded other components but they manage themselves (ex. SectionScroll)
  useEffect(() => {
    let listComponentsToAnimate;
    if (componentsToAnimate) {
      listComponentsToAnimate = Array.from(componentsToAnimate.values());
    }

    if (strip.current && controllerScrollAnimations) {
      // NOTE: skip first and last strip
      if (
        listComponentsToAnimate &&
        listComponentsToAnimate[0] !== strip.current &&
        listComponentsToAnimate[listComponentsToAnimate.length - 1] !==
          strip.current
      ) {
        if (
          deniedAnimationNodes &&
          deniedAnimationNodes?.size > 0 &&
          deniedNode
        ) {
          let containNodeDenied = false;
          // NOTE: check if stip contains node denied
          Array.from(deniedAnimationNodes).forEach((node) => {
            if (!strip.current?.contains(node)) {
              containNodeDenied = true;
            } else if (scene.current) {
              controllerScrollAnimations.removeScene(scene.current);
            }
            return null;
          });
          if (containNodeDenied) {
            setDeniedNode(false);
          }
        } else if (deniedNode) {
          setDeniedNode(false);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [controllerScrollAnimations, deniedNode]);

  // NOTE: set animation
  useEffect(() => {
    if (
      !deniedNode &&
      !scene.current &&
      strip.current &&
      controllerScrollAnimations
    ) {
      scene.current = new ScrollMagic.Scene({
        triggerElement: strip.current, // y value not modified, so we can use element as trigger as well
        offset: 0, // start a little later
        triggerHook: 1,
      })
        .setClassToggle(strip.current, styles.visible) // add class toggle
        .reverse(false)
        // .addIndicators({ name: "strip" }) // add indicators (requires plugin)
        .addTo(controllerScrollAnimations);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deniedNode]);

  return (
    <div
      ref={strip}
      className={cn({
        [styles.strip__animation]: controllerScrollAnimations && !deniedNode,
        [styles.active]: !deniedNode,
      })}
    >
      <CfStrip {...props} />
    </div>
  );
};

export default Strip;
